import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_IdDdWaiverJustificationForBhSuppSvs = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_IdDdWaiverJustificationForBhSuppSvs' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>ID/DD Waiver Justification for Behavior Support Services</h3></p>

                <p className='w-750'>
                    Based upon the Functional Behavior Assessment completed <input type='date' id='txtBehavior' name='txtBehavior' className='add-only w-180 custom-add-only' /> &nbsp; (date)
                    it is recommended that Behavior Support services are warranted.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    It is anticipated that approximately <input type='text' id='txtHours' name='txtHours' className='add-only w-200 custom-add-only' /> hours 
                    for <input type='text' id='txtMonths' name='txtMonths' className='add-only w-200 custom-add-only' /> months will be required to implement the Behavior Support Plan
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    Based upon the Functional Behavior Assessment completed, <input type='date' id='txtBehavior1' name='txtBehavior1' className='add-only w-180 custom-add-only' /> &nbsp; (date) it is recommended that direct Behavior Support services
                    are not warranted but there is a need for staff training.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    It is anticipated that approximately <input type='text' id='txtHours1' name='txtHours1' className='add-only w-200 custom-add-only' /> hours will be required to adequately train staff to manage identified behaviors.
                </p>


            </div>
        </form >

    )
}











